import React from "react";
import { AriaLabels, ElementType, EventNames, IconNames } from "../../../common/Constants";
import CommandButton from "../../common/commandbutton/CommandButton";

function EmailTranscriptButton(props) {
  const {
    type
  } = props;
  const customEvent = {
    elementType: ElementType.FooterEmailTranscriptButton,
    elementId: props === null || props === void 0 ? void 0 : props.id,
    eventName: EventNames.OnClick
  };
  return /*#__PURE__*/React.createElement(CommandButton, {
    id: props === null || props === void 0 ? void 0 : props.id,
    type: type,
    styles: props.styles,
    hoverStyles: props.hoverStyles,
    focusStyles: props.focusStyles,
    iconName: props.iconName ?? IconNames.Mail,
    imageIconProps: props.imageIconProps,
    onClick: props.onClick,
    ariaLabel: props.ariaLabel ?? AriaLabels.EmailTranscript,
    className: props.className,
    customEvent: customEvent
  });
}

export default EmailTranscriptButton;